import type { WalletAccount, WalletAddressType } from '../walletAccount';

type GetWalletAccountAddressByTypeParams = {
  type: WalletAddressType;
  walletAccount: WalletAccount;
};

export const getWalletAccountAddressByType = ({
  type,
  walletAccount,
}: GetWalletAccountAddressByTypeParams) => {
  return walletAccount.addressesWithTypes?.find(
    (address) => address.type === type
  )?.address;
};
